// extracted by mini-css-extract-plugin
export default {"progress":"LearningProgressCategory_progress__lo+ys","list":"LearningProgressCategory_list__+MVWD"};